/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCampaignDto
 */
export interface UpdateCampaignDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCampaignDto
     */
    ownerId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignDto
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignDto
     */
    endDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignDto
     */
    state?: string | null;
}

/**
 * Check if a given object implements the UpdateCampaignDto interface.
 */
export function instanceOfUpdateCampaignDto(value: object): value is UpdateCampaignDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    return true;
}

export function UpdateCampaignDtoFromJSON(json: any): UpdateCampaignDto {
    return UpdateCampaignDtoFromJSONTyped(json, false);
}

export function UpdateCampaignDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCampaignDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ownerId': json['owner_id'],
        'startDate': json['start_date'] == null ? undefined : json['start_date'],
        'endDate': json['end_date'] == null ? undefined : json['end_date'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function UpdateCampaignDtoToJSON(json: any): UpdateCampaignDto {
    return UpdateCampaignDtoToJSONTyped(json, false);
}

export function UpdateCampaignDtoToJSONTyped(value?: UpdateCampaignDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'owner_id': value['ownerId'],
        'start_date': value['startDate'],
        'end_date': value['endDate'],
        'state': value['state'],
    };
}

